var map = {
	"./Base": 724,
	"./Base/": 724,
	"./Base/index": 724,
	"./Base/index.js": 724,
	"./Base/style": 174,
	"./Base/style.js": 174,
	"./Clutch": 423,
	"./Clutch/": 423,
	"./Clutch/index": 423,
	"./Clutch/index.js": 423,
	"./Clutch/renderComponent": 1651,
	"./Clutch/renderComponent.js": 1651,
	"./Clutch/style": 1294,
	"./Clutch/style.js": 1294,
	"./NewUi": 1016,
	"./NewUi/": 1016,
	"./NewUi/index": 1016,
	"./NewUi/index.js": 1016,
	"./NewUi/style": 1295,
	"./NewUi/style.js": 1295,
	"./OldUi": 1017,
	"./OldUi/": 1017,
	"./OldUi/index": 1017,
	"./OldUi/index.js": 1017,
	"./OldUi/renderComponent": 1652,
	"./OldUi/renderComponent.js": 1652,
	"./OldUi/style": 1296,
	"./OldUi/style.js": 1296,
	"./SpireonNew": 1018,
	"./SpireonNew/": 1018,
	"./SpireonNew/index": 1018,
	"./SpireonNew/index.js": 1018,
	"./SpireonNew/renderComponent": 1653,
	"./SpireonNew/renderComponent.js": 1653,
	"./SpireonNew/style": 1297,
	"./SpireonNew/style.js": 1297,
	"./SpireonOld": 1019,
	"./SpireonOld/": 1019,
	"./SpireonOld/index": 1019,
	"./SpireonOld/index.js": 1019,
	"./SpireonOld/renderComponent": 1654,
	"./SpireonOld/renderComponent.js": 1654,
	"./SpireonOld/style": 1298,
	"./SpireonOld/style.js": 1298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;